import { connect } from 'react-redux';
import ProgramsComponent from '../components/programsComponent';
import { fetchProgramsDataIfNeeded } from '../actions/ProgramsAction';

const mapStateToProps = (state) => ({
    programsData: state.programs.programsData,
});

const mapDispatchToProps = (dispatch) => ({
    fetchProgramsDataIfNeeded: () => dispatch(fetchProgramsDataIfNeeded()),
});

const ProgramsContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(ProgramsComponent);

export default ProgramsContainer;
